import * as React from 'react';
import { useUiStore } from '@/store/uiStore';
import { useAuth } from '@/hooks/useAuth';
import { DeleteRow } from './shared/DeleteRow';
import deleteCreatorIcon from '@/assets/images/svg/delete_creator_icon.svg';
import deleteAccountIcon from '@/assets/images/svg/delete_account_icon.svg';

/**
 * DeleteSection Component
 *
 * Renders the critical danger zone actions in the Settings tab.
 * Uses global UI store to trigger confirmation modals.
 */
export const DeleteSection: React.FC = () => {
  const openModal = useUiStore((state) => state.openModal);
  const { user } = useAuth();

  const isDeletionPending = !!user?.deletion_requested_at;
  const noop = (): void => undefined;

  return (
    <div className='mt-auto flex flex-col gap-8'>
      {/*
        Action 1: Delete Creator Profile
        Removes echoes/drafts but keeps the user account active.
      */}
      <DeleteRow
        icon={deleteCreatorIcon}
        title='Delete Creator Profile'
        description='Remove all your echoes and creator data. Your account will remain active.'
        buttonLabel='Delete Profile'
        onAction={() => openModal('deleteCreator')}
      />

      {/*
        Action 2: Delete Account
        Permanently wipes all user data and logs them out.
      */}
      <DeleteRow
        icon={deleteAccountIcon}
        title='Delete Account'
        description={
          isDeletionPending
            ? 'Your account is scheduled for deletion.'
            : 'Permanently delete your account and all associated data. This cannot be undone.'
        }
        buttonLabel={isDeletionPending ? 'Stop' : 'Delete Account'}
        onAction={isDeletionPending ? noop : () => openModal('deleteAccount')}
        isLoading={false}
      />
    </div>
  );
};
